import Vue from "vue";
import Router from "vue-router";
import MainPage from "@/components/pages/MainPage.vue";
import CategoryWrapper from "@/components/pages/categories/CategoryWrapper.vue";
import CategoriesPage from "@/components/pages/categories/CategoriesPage.vue";
import CategoryPage from "@/components/pages/categories/CategoryPage.vue";
import ProductPage from "@/components/pages/ProductPage.vue";
import ContactsPage from "@/components/pages/ContactsPage.vue";
import PayPage from "@/components/pages/PayPage.vue";
import CartPage from "@/components/pages/CartPage.vue";
import SolutionsPage from "@/components/pages/SolutionsPage.vue";
import VlazhnyePomPage from "@/components/pages/VlazhnyePomPage.vue";
import ZhilyePomPage from "@/components/pages/ZhilyePomPage.vue";
import BalkonyPage from "@/components/pages/BalkonyPage.vue";
import GaragePage from "@/components/pages/GaragePage.vue";
import KukhnyaPage from "@/components/pages/KukhnyaPage.vue";
import PodvalPage from "@/components/pages/PodvalPage.vue";
import FasadPage from "@/components/pages/FasadPage.vue";
import AboutWrapper from "@/components/pages/about/AboutWrapper.vue";
import AboutPage from "@/components/pages/about/AboutPage.vue";
import InnovationPage from "@/components/pages/about/InnovationPage.vue";
import LabPage from "@/components/pages/about/LabPage.vue";
import PlantPage from "@/components/pages/about/PlantPage.vue";
import ArticlesPage from "@/components/pages/articles/ArticlesPage.vue";
import ArticleViewPage from "@/components/pages/articles/ArticleViewPage.vue";
import CalcPage from "@/components/pages/CalcPage.vue";
import VideoPage from "@/components/pages/VideoPage.vue";
import ObjectsPage from "@/components/pages/ObjectsPage.vue";
import SuccessPayPage from "@/components/pages/SuccessPayPage.vue";
import FailPayPage from "@/components/pages/FailPayPage.vue";

Vue.use(Router);

export default new Router({
  mode: process.env.CORDOVA_PLATFORM ? "hash" : "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "main",
      component: MainPage,
    },
    {
      path: "/catalog/:groupId/product/:id",
      name: "product",
      component: ProductPage,
    },
    {
      path: "/catalog",
      name: "categoryWrap",
      component: CategoryWrapper,
      children: [
        {
          path: "/",
          name: "categories",
          component: CategoriesPage,
        },
        {
          path: ":groupId",
          name: "category",
          component: CategoryPage,
          meta: {
            isSub: false,
          },
        },
      ],
    },
    {
      path: "/catalog",
      name: "subCategoryWrap",
      component: CategoryWrapper,
      children: [
        {
          path: ":pGroupId/:groupId",
          name: "subCategory",
          component: CategoryPage,
          meta: {
            isSub: true,
          },
        },
      ],
    },
    {
      path: "/contacts",
      name: "contacts",
      component: ContactsPage,
    },
    {
      path: "/pay",
      name: "pay",
      component: PayPage,
    },
    {
      path: "/cart",
      name: "cart",
      component: CartPage,
    },
    {
      path: "/solutions",
      name: "solutions",
      component: SolutionsPage,
    },
    {
      path: "/vlazhnye-pomeshcheniya",
      name: "vlazhnye",
      component: VlazhnyePomPage,
    },
    {
      path: "/zhilye-pomeshcheniya",
      name: "zhilye",
      component: ZhilyePomPage,
    },
    {
      path: "/balkony-i-terassy",
      name: "balkony",
      component: BalkonyPage,
    },
    {
      path: "/garage",
      name: "garage",
      component: GaragePage,
    },
    {
      path: "/kukhnya",
      name: "kukhnya",
      component: KukhnyaPage,
    },
    {
      path: "/podval",
      name: "podval",
      component: PodvalPage,
    },
    {
      path: "/fasad",
      name: "fasad",
      component: FasadPage,
    },
    {
      path: "/about",
      name: "aboutWrap",
      component: AboutWrapper,
      children: [
        {
          path: "/",
          name: "about",
          component: AboutPage,
        },
        {
          path: "plants",
          name: "plants",
          component: PlantPage,
        },
        {
          path: "innovations",
          name: "innovations",
          component: InnovationPage,
        },
        {
          path: "labs",
          name: "labs",
          component: LabPage,
        },
      ],
    },
    {
      path: "/articles",
      name: "articles",
      component: ArticlesPage,
    },
    {
      path: "/article/:id",
      name: "article",
      component: ArticleViewPage,
    },
    {
      path: "/calculator",
      name: "calc",
      component: CalcPage,
    },
    {
      path: "/video/:id",
      name: "video",
      component: VideoPage,
    },
    {
      path: "/objects",
      name: "objects",
      component: ObjectsPage,
    },
    {
      path: "/success-pay",
      name: "successPay",
      component: SuccessPayPage,
    },
    {
      path: "/fail-pay",
      name: "failPay",
      component: FailPayPage,
    },
    ,
    {
      path: "/page-not-found",
      alias: "*",
      component: { render: (h) => h("div", ["404! Страница не найдена"]) },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
